export default function getTripDuration(item) {
    if(item === undefined || item.dateRange === undefined) return 0;
    const dateRange = item?.dateRange;
    const [startYear, startMonth, startDay] = dateRange?.start;
    const [endYear, endMonth, endDay] = dateRange?.end;

    const startDate = new Date(startYear, startMonth - 1, startDay);
    const endDate = new Date(endYear, endMonth - 1, endDay);

    const differenceInMilliseconds = endDate - startDate;
    return differenceInMilliseconds / (1000 * 60 * 60 * 24);
}
